import axios from "@/app/Axios";

class Reposiciones {
    //REPOSICIONES EJERCITO
    async listacertificadosreposicionesejercito() {
        try {
            const response = await axios.get("/certificadosrepo/getcertificadosrepo");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //REPOSICIONES AEREA
    async listacertificadosreposicionesaerea() {
        try {
            const response = await axios.get("/certificadosrepo/getcertificadosrepoaerea");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //REPOSICIONES ARMADA
    async listacertificadosreposicionesarmada() {
        try {
            const response = await axios.get("/certificadosrepo/getcertificadosrepoarmada");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //EJERCITO
    async listacertificadosresarcimientosejercito() {
        try {
            const response = await axios.get("/certificados/getcertificados");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosejercitocargador() {
        try {
            const response = await axios.get("/certificados/getcertificadoscargador");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosejercitocu() {
        try {
            const response = await axios.get("/certificados/getcertificadoscu");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosejercitosa() {
        try {
            const response = await axios.get("/certificados/getcertificadossa");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //AEREA
    async listacertificadosresarcimientosaerea() {
        try {
            const response = await axios.get("/certificados/getcertificadosaerea");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosaereacargador() {
        try {
            const response = await axios.get("/certificados/getcertificadoscargadoraerea");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosaereacu() {
        try {
            const response = await axios.get("/certificados/getcertificadoscuaerea");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosaereasa() {
        try {
            const response = await axios.get("/certificados/getcertificadossaaerea");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //ARMADA
    async listacertificadosresarcimientosarmada() {
        try {
            const response = await axios.get("/certificados/getcertificadosarmada");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosarmadacargador() {
        try {
            const response = await axios.get("/certificados/getcertificadoscargadorarmada");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosarmadacu() {
        try {
            const response = await axios.get("/certificados/getcertificadoscuarmada");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listacertificadosresarcimientosarmadasa() {
        try {
            const response = await axios.get("/certificados/getcertificadossaarmada");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }


    async listaresarcimientoscuchilloget() {
        try {
            const response = await axios.get("/ejercito/cuchilloresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async savePistolaResarcimiento(pistolapost) {
        try {
            const response = await axios.post("/resarcimiento/pistolaresarcimientoregistro", pistolapost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    //pistolacargadorresarcimientoregistro
    async savePistolaCargadorResarcimiento(pistolapost) {
        try {
            const response = await axios.post("/resarcimiento/pistolacargadorresarcimientoregistro", pistolapost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async saveCuchilloResarcimiento(cuchillopost) {
        try {
            const response = await axios.post("/resarcimiento/cuchilloresarcimientoregistro", cuchillopost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    //
    async saveResarcimientoPistola(armaspost) {
        try {
            const response = await axios.post("/certificados/certificadosregistro", armaspost)
            console.log("Esta es la respuesta del registro del certificado:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }

    

}

export default Reposiciones;